// @flow
import './TimelineDatapointDialog.css';

import * as React from 'react';
import Modal from '../modals/Modal2';
import DataTimeline from '../protocol/DataTimeline';
import TimelineDatapointForm from './TimelineDatapointForm';
import { KeyFrameMetadataEntry } from '../autogenerated/ZoomBridge';
import HashMap from '../protocol/HashMap';
import VideoController from './VideoController';
import t from '../i18n/I18n';
import { KeyCode } from '../util/Constants';
import KeydownConfig from '../keyboard-shortcuts/KeydownConfig';
import KeyboardShortcuts from '../keyboard-shortcuts/KeyboardShortcuts';

type Props = {
  dataTimeline: DataTimeline,
  keyFrameMetadataEntry: KeyFrameMetadataEntry,
  onClose: Function,
  onSubmit: Function,
  videoController: VideoController
};

type State = {
  startTimeInvalid: boolean,
  stopTimeInvalid: boolean
};

export default class TimelineDatapointDialog extends React.Component<Props, State> {
  state = {
    startTimeInvalid: false,
    stopTimeInvalid: false
  };

  componentDidMount() {
    this.addKeyListeners();
  }
  componentWillUnmount() {
    this.removeKeyListeners();
  }

  addKeyListeners = () => {
    KeyboardShortcuts.add(new KeydownConfig('TIMELINE_DATAPOINT_DIALOG', this.onSubmit, [KeyCode.ENTER], [], false));
    KeyboardShortcuts.add(
      new KeydownConfig('TIMELINE_DATAPOIN_DIALOG', this.props.onClose, [KeyCode.ESCAPE], [], false)
    );
  };

  removeKeyListeners = () => {
    KeyboardShortcuts.remove('TIMELINE_DATAPOINT_DIALOG');
    KeyboardShortcuts.remove('TIMELINE_DATAPOIN_DIALOG');
  };
  getKey = () => {
    const { keyFrameMetadataEntry } = this.props;
    return keyFrameMetadataEntry.getMetadataMap().toArray()[0].key;
  };

  onDatapointChange = (prop: string, value: string | number) => {
    const { keyFrameMetadataEntry, videoController } = this.props;
    const { _startTime, _endTime } = keyFrameMetadataEntry;
    const duration = videoController.duration * 1000;
    switch (prop) {
      case 'label':
        const map = new HashMap();
        map.put(this.getKey(), value);
        keyFrameMetadataEntry.setMetadataMap(map);
        break;
      case 'startTimeMs':
        if (value === null || isNaN(value) || value >= _endTime || value >= duration) {
          this.setState({ startTimeInvalid: true });
        } else {
          this.setState({ startTimeInvalid: false });
          keyFrameMetadataEntry.setStartTime(value);
        }
        break;
      case 'stopTimeMs':
        if (value === null || isNaN(value) || value <= _startTime || value >= duration) {
          this.setState({ stopTimeInvalid: true });
        } else {
          this.setState({ stopTimeInvalid: false });
          keyFrameMetadataEntry.setEndTime(value);
        }
        break;
    }

    this.forceUpdate();
  };

  onSubmit = () => {
    if (!this.isSaveDisabled()) this.props.onSubmit();
  };

  isSaveDisabled = () => {
    const { keyFrameMetadataEntry: entry } = this.props;
    const { startTimeInvalid, stopTimeInvalid } = this.state;
    return (
      !entry
        .getMetadataMap()
        .get(this.getKey())
        .trim() ||
      startTimeInvalid ||
      stopTimeInvalid
    );
  };

  render() {
    const { keyFrameMetadataEntry, onClose } = this.props;
    const { startTimeInvalid, stopTimeInvalid } = this.state;

    const title = t('ADD_DATA_POINT');

    const props = {
      name: 'TimelineDatapointDialog',
      title,
      onClose,
      buttons: [
        { label: t('CANCEL'), type: 'CANCEL', onClick: onClose },
        { label: title, type: 'PRIMARY', onClick: this.onSubmit, disabled: this.isSaveDisabled() }
      ]
    };

    return (
      <Modal {...props} closeOnEsc closeOnOutsideClick>
        <TimelineDatapointForm
          keyFrameMetadataEntry={keyFrameMetadataEntry}
          videoController={this.props.videoController}
          startTimeInvalid={startTimeInvalid}
          stopTimeInvalid={stopTimeInvalid}
          onChange={(prop: string, value: string) => this.onDatapointChange(prop, value)}
          groupName={this.getKey()}
          onSubmit={this.onSubmit}
        />
      </Modal>
    );
  }
}
